<template>
  <v-card>
    <v-card-title class="justify-space-between">
      Overview

      <v-btn small color="primary" :to="`/funds/${houseFundData.fundId}`">
        Ver fundo
      </v-btn>
    </v-card-title>

    <v-container fluid class="pa-0">
      <v-row no-gutters>
        <template v-for="(item, itemIndex) of detailFields">
          <v-col cols="12" sm="4" lg="2" :key="itemIndex">
            <v-list-item two-line dense>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>

                <v-list-item-subtitle :class="item.class">
                  {{ item.value }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { sumBy } from 'lodash';
import { formatCurrency, formatNumber, formatPercentage } from '@/utils/format-utils';

const formatReturn = (val) => formatPercentage(val, { maximumFractionDigits: 4 });

const formatQuota = (val) => formatCurrency(val, {
  minimumFractionDigits: 8,
  maximumFractionDigits: 8,
});

export default {
  name: 'HoldingGeneralInfo',

  props: {
    details: {
      type: Object,
      required: true,
    },

    houseFundData: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    netValue: (vm) => vm.details.netValue ?? vm.details.calculatedNetValue,
    price: (vm) => vm.details.price ?? vm.details.calculatedPrice,
    totalValue: (vm) => sumBy(vm.details.pnRHoldings, 'value'),

    detailFields: (vm) => [
      {
        text: 'Patrimônio liquido',
        value: formatCurrency(vm.netValue),
        class: vm.netValue < 0 ? 'error--text' : '',
      },

      {
        text: 'Cota líquida',
        value: formatQuota(vm.price),
        class: vm.price < 0 ? 'error--text' : '',
      },

      {
        text: 'Quantidade de cotas',
        value: formatNumber(vm.details.shareQuantity),
        class: vm.details.shareQuantity < 0 ? 'error--text' : '',
      },

      {
        text: 'Fechamento de caixa',
        value: formatCurrency(vm.details.cashHoldings?.value),
        class: vm.details.cashHoldings?.value < 0 ? 'error--text' : '',
      },

      {
        text: 'Retorno diário',
        value: formatReturn(vm.details.dailyReturn),
        class: vm.details.dailyReturn < 0 ? 'error--text' : '',
      },

      {
        text: 'Contas a Pagar e Receber',
        value: formatCurrency(vm.totalValue),
        class: vm.totalValue < 0 ? 'error--text' : '',
      },
    ],
  },
};
</script>
